
export default {
  SET_CREW_ACCOUNT(state, data) {
    state.crewAccount = data;
  },
  CLEAR_CREW_ACCOUNT(state) {
    state.crewAccount = {};
  },
  SET_CREW_LIST(state, data) {
    state.crewList = data;
  },
}
